import { render, staticRenderFns } from "./SmallPupilOptometry.vue?vue&type=template&id=1fd30772&scoped=true&"
import script from "./SmallPupilOptometry.vue?vue&type=script&lang=js&"
export * from "./SmallPupilOptometry.vue?vue&type=script&lang=js&"
import style0 from "./SmallPupilOptometry.vue?vue&type=style&index=0&id=1fd30772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd30772",
  null
  
)

export default component.exports